import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Slider from "react-slick";

import banner1 from "../assets/images/banner-bg1.jpg";
import banner2 from "../assets/images/banner-bg2.jpg";
import banner3 from "../assets/images/banner-bg3.jpg";

export default function Hero() {
    const navigate = useNavigate();

    const [destinations, setDestinations] = useState([]);

    const [form, setForm] = useState({
        destination: "",
        checkIn: "",
        checkOut: "",
        guests: 2,
    });

    // ✅ HERO SLIDES (local images)
    const [slides] = useState([banner1, banner2, banner3]);

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        fade: true,
        pauseOnHover: false,
        cssEase: "linear",
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.destination.trim()) {
            alert("Please select a destination");
            return;
        }

        navigate("/search-hotels", { state: form });
    };

    useEffect(() => {
        api
            .get("/destinations")
            .then((res) => setDestinations(res.data))
            .catch((err) => console.log(err));
    }, []);

    return (
        <section className="relative min-h-[880px] md:min-h-[600px] lg:min-h-[650px] xl:min-h-[650px] overflow-hidden">

            {/* 🔥 BACKGROUND SLIDER */}
            <div className="absolute inset-0 z-0 h-full">
                <Slider className="hero-slider" {...sliderSettings}>
                    {slides.map((img, i) => (
                        <div key={i}>
                            <div
                                className="w-full h-14 h-full min-h-[880px] md:min-h-[600px] lg:min-h-[650px] xl:min-h-[650px] bg-cover bg-center"
                                style={{ backgroundImage: `url(${img})` }}
                            />
                        </div>
                    ))}
                </Slider>

                {/* DARK OVERLAY */}
                <div className="absolute inset-0 bg-black/30" />
            </div>

            {/* CONTENT */}
            <div className="relative z-10 flex items-center justify-center min-h-[880px] md:min-h-[600px] lg:min-h-[650px] xl:min-h-[650px]">
                <div className="container mx-auto px-6 text-center text-white">

                    {/* TEXT */}
                    <div className="max-w-3xl mx-auto">
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">
                            Find The Best Hotel Deals In UAE
                        </h1>

                        <p className="text-white/80 mb-10">
                            Compare luxury, budget & beach resorts across Dubai, Abu Dhabi & more
                        </p>
                    </div>

                    {/* FORM */}
                    <form
                        onSubmit={handleSubmit}
                        className="mt-10 md:mt-14 relative max-w-6xl mx-auto"
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 rounded-3xl blur-2xl opacity-20"></div>

                        <div className="relative bg-white/10 backdrop-blur-2xl border border-white/20 rounded-3xl shadow-2xl p-6 md:p-10">

                            <div className="text-center mb-8">
                                <h2 className="text-xl md:text-3xl font-bold">
                                    Search Your Perfect Hotel ✨
                                </h2>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-5">

                                {/* DESTINATION */}
                                <div className="text-left min-w-0">
                                    <select
                                        name="destination"
                                        value={form.destination}
                                        onChange={handleChange}
                                        className="w-full h-14 min-w-0 mt-2 px-4 py-3 rounded-xl bg-white text-gray-900"
                                    >
                                        <option value="">Select Destination</option>

                                        {destinations.map((dest) => (
                                            <option key={dest.id} value={dest.name}>
                                                {dest.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* CHECK IN */}
                                <div className="min-w-0">
                                    <input
                                        type="date"
                                        name="checkIn"
                                        value={form.checkIn}
                                        onChange={handleChange}
                                        className="w-full h-14 min-w-0 max-w-full block mt-2 px-4 py-3 rounded-xl bg-white text-gray-900 appearance-none"
                                    />
                                </div>

                                {/* CHECK OUT */}
                                <div className="min-w-0">
                                    <input
                                        type="date"
                                        name="checkOut"
                                        value={form.checkOut}
                                        onChange={handleChange}
                                        className="w-full h-14 min-w-0 max-w-full block mt-2 px-4 py-3 rounded-xl bg-white text-gray-900 appearance-none"
                                    />
                                </div>

                                {/* GUESTS */}
                                <div className="min-w-0">
                                    <div className="flex items-center justify-between px-4 py-3 mt-2 rounded-xl bg-white text-gray-900">
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setForm({
                                                    ...form,
                                                    guests: Math.max(1, form.guests - 1),
                                                })
                                            }
                                        >
                                            −
                                        </button>

                                        <span className="font-semibold">
                                            {form.guests}
                                        </span>

                                        <button
                                            type="button"
                                            onClick={() =>
                                                setForm({
                                                    ...form,
                                                    guests: form.guests + 1,
                                                })
                                            }
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>

                            </div>

                            {/* BUTTON */}
                            <div className="mt-8 text-center">
                                <button
                                    type="submit"
                                    className="bg-white text-blue-600 font-bold px-12 py-3 rounded-2xl hover:bg-gray-100 transition shadow-lg"
                                >
                                    Search Hotels
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}